import { Button, Form, Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { FacebookOutlined, TwitterOutlined } from '@ant-design/icons';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import Heading from '../../../../components/heading/heading';
import { login, logOut } from '../../../../redux/authentication/actionCreator';
import {
  fbAuthLogin,
  fbAuthLogout,
  fbAuthLoginWithFacebook,
  fbAuthLoginWithGoogle,
} from '../../../../redux/firebase/auth/actionCreator';
import { AuthWrapper } from './style';
import config from '../../../../config/config';
import Cookies from 'js-cookie';

const SignIn = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading, error, errorMessage, isFbAuthenticate, isLogin, email, isLoggedIn } = useSelector((state) => {
      return {
        error: state.firebaseAuth.error,
        errorMessage: state.firebaseAuth.errorMessage,
        isLoading: state.firebaseAuth.loading,
        isLogin: state.firebaseAuth.isLogin,
        isLoggedIn: state.auth.login,
        isFbAuthenticate: state.fb.auth.uid,
        email: state.fb.auth.email,
      };
    });
  const [form] = Form.useForm();
  const [state, setState] = useState({
    checked: null,
  });

  useEffect(() => {
    if (isLogin) {
      // dispatch(login());
      // history.push('/admin');
    } else {
      // dispatch(fbAuthLogout(logOut()));
      // history.replace('/');
    }
  }, [isLogin]);
  
  const handleSubmit = async ( values ) => {
    await dispatch(fbAuthLogin(values, history))
  };

  const onChange = checked => {
    setState({ ...state, checked });
  };
  return (
    <AuthWrapper>
    <p className="auth-notice" >
      {/* Don&rsquo;t have an account? <NavLink to="/register">Sign up now</NavLink> */}
      <Link
        to="/admin"
      > 
        <img
          src={
              require(`../../../../static/img/Logo_Dark.png`)
          }
          alt="" style={{width:"180px"}}
        />
      </Link>
    </p>
    <div className="auth-contents">
    <Form name="login" form={form} onFinish={handleSubmit} layout="vertical">
        <Heading as="h3">
          Sign in to <span style={{color:"#49C6F3"}}>Supplyfied</span>
        </Heading>
        <Form.Item
          name="email"
          rules={[{ message: 'Please enter valid Email !', required: true ,type: "email"},]}
          // initialValue= "name@example.com"
          label="Email Address"
          type="email"
        >
          <Input placeholder='Email Address'/>
        </Form.Item>
        <Form.Item name="password" rules={[
        {
          required: true,
          validator: async (_, password) => {
            if (!password || password.length < 8) {
              return Promise.reject(new Error('Password should be at least 8 characters'));
            }
          },
        },
      ]} label="Password">
          <Input.Password placeholder='Password'/>
        </Form.Item>
        <div className="auth-form-action">
          <Checkbox onChange={onChange} checked={state.checked}>
            Keep me logged in
          </Checkbox>
          {/* <NavLink className="forgot-pass-link" to="/forgotPassword">
            Forgot password?
          </NavLink> */}
        </div>
        <Form.Item >
          <Button className="btn-signin" htmlType="submit" type="primary" size="large">
            {isLoading ? 'Loading...' : 'Sign In'}
          </Button>
          {/* {error && error !== "undefined" ? <p style={{color: "red"}} > { JSON.parse(error.message).error.message }</p> : null} */}
          {error  ? <p style={{color: "red"}} > { errorMessage }</p> : null}
        </Form.Item>
        {/* <p className="form-divider">
          <span>Or</span>
        </p>
        <ul className="social-login">
          <li>
            <Link className="google-signup" to="#">
              <img src={require('../../../../static/img/google.png')} alt="" />
              <span>Sign in with Google</span>
            </Link>
          </li>
          <li>
            <Link className="facebook-sign" to="#">
              <FacebookOutlined />
            </Link>
          </li>
          <li>
            <Link className="twitter-sign" to="#">
              <TwitterOutlined />
            </Link>
          </li>
        </ul>
        <div className="auth0-login">
          <Link to="#" onClick={() => lock.show()}>
            Sign In with Auth0
          </Link>
          <Link to="/fbSignIn">Sign In With Firebase</Link>
        </div> */}
      </Form>
    </div>
  </AuthWrapper>
    // <AuthWrapper>
    //   <p className="auth-notice">
    //     Don&rsquo;t have an account? <NavLink to="/fbRegister">Sign up now</NavLink>
    //   </p>
    //   <div className="auth-contents">
    //     <Form name="login" form={form} onFinish={handleSubmit} layout="vertical">
    //       <Heading as="h3">
    //         Sign in With Firebase to <span className="color-secondary">Admin</span>
    //       </Heading>
    //       <Form.Item
    //         name="email"
    //         rules={[{ message: 'Please input your Email!', required: true }]}
    //         label="Email Address"
    //       >
    //         <Input />
    //       </Form.Item>
    //       <Form.Item
    //         rules={[{ message: 'Please input your password!', required: true }]}
    //         name="password"
    //         label="Password"
    //       >
    //         <Input.Password placeholder="Password" />
    //       </Form.Item>
    //       <div className="auth-form-action">
    //         <Checkbox onChange={onChange}>Keep me logged in</Checkbox>
    //         {/* <NavLink className="forgot-pass-link" to="/forgotPassword">
    //           Forgot password?
    //         </NavLink> */}
    //       </div>
    //       {error ? <p>{error.message}</p> : null}
    //       <Form.Item>
    //         <Button className="btn-signin" htmlType="submit" type="primary" size="large">
    //           {isLoading ? 'Loading...' : 'Sign In'}
    //         </Button>
    //       </Form.Item>
    //       <p className="form-divider">
    //         <span>Or</span>
    //       </p>
    //       <ul className="social-login">
    //         <li>
    //           <Link onClick={() => dispatch(fbAuthLoginWithGoogle())} className="google-signup" to="#">
    //             <img src={require('../../../../static/img/google.png')} alt="" />
    //             <span>Sign in with Google</span>
    //           </Link>
    //         </li>
    //         <li>
    //           <Link onClick={() => dispatch(fbAuthLoginWithFacebook())} className="facebook-sign" to="#">
    //             <FacebookOutlined />
    //           </Link>
    //         </li>
    //         <li>
    //           <Link className="twitter-sign" to="#">
    //             <TwitterOutlined />
    //           </Link>
    //         </li>
    //       </ul>
    //     </Form>
    //   </div>
    // </AuthWrapper>
  );
};

export default SignIn;
